export const OP_CODE = {
    MAINTENANCE_MENU: 'MMENU',
    CONDITIONAL_MAINT_MENU: 'CMENU',
    DIAGNOSIS: 'DIAG',
    WRITE_YOUR_OWN: 'WYO',
    SKIP_REASON: 'reason',
} as const;

export const OP_ID_PREFIX = {
    MAINTENANCE_MENU: 'maintMenu',
    DIAGNOSIS: 'diagnosis',
    INDIVIDUAL_SERVICE: 'individualService',
    SKIP_REASON: 'skipReason',
} as const;
